import { Component } from '@angular/core';
import { AppState } from '../../../../../app/app.global';
import { App,LoadingController} from 'ionic-angular';
import { PatentDetail } from '../detail/detail';
import { HttpService } from '../../../../../providers/service/httpservice';
import { PATENTLIST,PATENTYEARLIST } from '../../../../../providers/config/serviceurl';
import { StorageService } from '../../../../../providers/service/storageservice';
@Component({
	selector: 'list',
  templateUrl: 'list.html'
})

export class PatentList {
	issue:string='';
	issues:any=[];
	artsitems:any=[];
	scienceitems:any=[];
	pageIndex = 1;
	pageNumber = 20;
  public loading;
  user:any;
  params:any=[];
  count:any;
	constructor(public global: AppState,public appCtrl: App,private httpService:HttpService,
		private loadCtrl:LoadingController) {
			this.count = StorageService.getObj('zlcount');
			this.issue = StorageService.getObj('zlissue');
			this.issues = StorageService.getObj('zlissues');
			this.artsitems = StorageService.getObj('zlartsitems');
			this.scienceitems = StorageService.getObj('zlscienceitems');
			this.user = StorageService.getObj('currentUser');
			this.params = {'hd':this.user.hd};
			this.loadData(this.params);
	}

	getList(params){
		this.loading = this.loadCtrl.create({
			content: '加载中...',
		});
		this.httpService.post(PATENTLIST,params).then(anyObj =>this.handleList(anyObj));
		this.loading.dismiss();//加载动画结束
	}

	//跳转详情
	openDetail(item){
		this.appCtrl.getRootNav().push(PatentDetail,item);
	}

	//下拉刷新
  doRefresh(refresher){
  	  setTimeout(() => {
    	 this.pageIndex = 1;
    	 this.params = {'pageNo':this.pageIndex,'pageSize':this.pageNumber,'hd':this.user.hd,'queryStr':this.issue};
    	 this.artsitems = [];
    	 this.scienceitems = [];
    	 this.getList(this.params);
    	 refresher.complete();
  	  }, 1000);
  }

  //上拉加载
	loadMore(refresher){
		setTimeout(() => {
				this.pageIndex++;
				this.params = {'pageNo':this.pageIndex,'pageSize':this.pageNumber,'hd':this.user.hd,'queryStr':this.issue};
				this.getList(this.params);
	      refresher.complete();
	  }, 500);

	}

	loadData(params){
		this.loading = this.loadCtrl.create({
			content: '加载中...',
		});
		this.httpService.post(PATENTYEARLIST,params).then(anyObj =>this.handleYearList(anyObj));
		this.httpService.post(PATENTLIST,params).then(anyObj =>this.handleList(anyObj));
	  this.loading.dismiss();//加载动画结束
	}

	handleList(obj:any){
  	if(obj){
  		var vk:any=[];
  		var lk:any=[];
  		this.count = obj.count;
  		StorageService.setObj("zlcount",this.count);
  		var length = obj.list.length;
  		if(this.artsitems == null){
  			this.artsitems = [];
  		}
  		if(this.scienceitems == null){
  			this.scienceitems = [];
  		}
  		for(var i=0;i<length;i++){
  			this.issue = obj.list[0].nf;
  			StorageService.setObj("zlissue",this.issue);
  			if(obj.list[i].sjly!=null&&obj.list[i].sjly=="文科"){
  				this.artsitems.push(obj.list[i]);
  				vk.push(obj.list[i]);
  			}else if(obj.list[i].sjly!=null&&obj.list[i].sjly=="理科"){
  				this.scienceitems.push(obj.list[i]);
  				lk.push(obj.list[i]);
  			}
  		}
  		//第一次加载数据的时候储存信息
  		if(this.pageIndex == 1){
  			this.artsitems = vk;
  			this.scienceitems = lk;
  			StorageService.setObj("zlartsitems",this.artsitems);
  			StorageService.setObj("zlscienceitems",this.scienceitems);
  		}
	}
  }

	handleYearList(obj:any){
  	if(obj){
  		var year:any=[];
  		var length = obj.list.length;
  		if(this.issues == null){
  			this.issues = [];
  		}
  		for(var i=0;i<length;i++){
  			if(this.issues.indexOf(obj.list[i].NF)<0){
  				this.issues.push(obj.list[i].NF);
  			}
  			year.push(obj.list[i].NF);
  		}
  		//第一次加载数据的时候储存信息
  		if(this.pageIndex == 1){
  			this.issues = year;
  			StorageService.setObj("zlissues",this.issues);
  		}
  		
		}
  }

	//查询年份
	issueSelect($event){
		this.artsitems = [];
    	this.scienceitems = [];
		this.pageIndex = 1;
		this.pageNumber = 20;
		this.params = {'pageNo':this.pageIndex,'pageSize':this.pageNumber,'hd':this.user.hd,'queryStr':$event};
		this.getList(this.params);
	}
}



// WEBPACK FOOTER //
// ./src/pages/application/research/patent/list/list.ts